import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToHash = (): JSX.Element | null => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [hash]);

  return null;
};
